<template>
  <q-dialog v-model="isModalActive" persistent>
    <q-card class="news-dialog-card">
      <q-card-section>
        <div class="text-h6">{{ currentSchemeItem.introduction }}</div>
      </q-card-section>

      <q-card-section class="q-pt-none">
        <div v-html="currentSchemeItem.body"></div>
      </q-card-section>

      <q-card-actions align="right" class="bg-white text-teal">
        <q-btn flat label="OK" @click="disableModal()" />
      </q-card-actions>
    </q-card>
  </q-dialog>
</template>

<script>
import { computed } from "vue";
import store from "../../store/index.js";

export default {
  setup() {
    const isModalActive = computed({
      get: () => store.state.salesForce.showSchemeDialog,
    });

    const currentSchemeItem = computed({
      get: () => store.state.salesForce.currentSchemeItemPerCustomer,
    });

    const disableModal = () => {
      store.commit("salesForce/disableSchemeModal");
    };

    return {
      currentSchemeItem,
      isModalActive,
      disableModal,
    };
  },
};
</script>
